const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const Menu = function(){

    const _body         = $('body');
    var _menuRight      = $('.navs.nav-right');
    var menuAll         = $('.menu-r-category');
    
    const scrollHeader = function (el) {
       
        let headerH = $(el).height();

/*         if($(window).scrollTop() > headerH) {
            document.getElementById('header').classList.add('scrolling');
            // $("#ico-whats").addClass("whats-min");
        }else{
            document.getElementById('header').classList.remove('scrolling');
            // $("#ico-whats").removeClass("whats-min");
        } */
        if( $(window).width() < 768 ) {
            if( $(window).scrollTop() >  headerH ){
                $(".tools-float").addClass('scrolling');
            } else{
                $(".tools-float").removeClass('scrolling');
            }
        }

        if( $(window).width() > 1200 ) {

            if( $(window).scrollTop() >  headerH ){
                //$("#header-logo-menu").addClass('motion-in');
                $(el).addClass('scrolling');
                
                // ico float contact
            } else{
                // $("#header-logo-menu").removeClass('motion-in');
                $(el).removeClass('scrolling');
                //$("#ico-float-fale").removeClass('scrolling');
            }

        
        } else {

            if( $(window).scrollTop() >  headerH){
                //$(el).addClass('scrolling');
                $("#bt-menu-mobile").addClass('fixed');
            } else{
                //$(el).removeClass('scrolling');
                $("#bt-menu-mobile").removeClass('fixed')
            }            

        }

    }


    const menuMobile = ((_this) => {
        let layerMenu = $("#layer-menu");
        //$('#bt-menu-mobile').toggleClass('motion-in');
        $("#wrap-sandwitch,#nav-icon3").toggleClass('open');
        menuAll.removeClass('actived');
        $('.nav-left a').removeClass('actived');
        _menuRight.removeClass('actived');
        layerMenu.toggleClass('actived');
        if($(window).width() < 768){
            _body.toggleClass('scroll-off');
        }

    });

    const showMenuCategory = (e) => {

        e.preventDefault();

        var _this           = $(e.currentTarget);
        var menuSelected    = _this.attr('data-menu');
    
        //reset all
        $('.nav-left a').removeClass('actived');
        menuAll.removeClass('actived');
        _menuRight.removeClass('actived');

        _this.addClass('actived');
        
        setTimeout(() => {
            $("#"+menuSelected).addClass('actived');
            _menuRight.addClass('actived');
        }, 400);

    }

    return {
        init : function () {

            scrollHeader("#header");
            //scrollActiveMenu();

            $(window).on('scroll', function(){
                scrollHeader("#header");
            });
            
            //new
            $('#wrap-sandwitch, .link-menu').on('click', function(){
                $("#wrap-sandwitch").toggleClass('open');
                menuMobile($(this));                
            });

            $(document).on('click', '.menu-category', showMenuCategory);
            
        }
    }

}();

module.exports = Menu;